// extracted by mini-css-extract-plugin
export default {"section":"Lq-z","inSectionButton":"Mq-z","addressCard":"Nq-z","disabled":"Oq-z","cautionBox":"Pq-z","failureBox":"Qq-z","fade-out":"Rq-z","successBox":"Sq-z"};